import React, { useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput,
    Typography,
    CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Auth from "apis/auth/auth.api";

const authApi = new Auth();

const ForgotPassword = () => {
    const navigate = useNavigate();

    const [step, setStep] = useState(1);

    const [phone, setPhone] = useState("");
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSendOtp = async () => {
        if (!phone.trim()) {
            return toast.error("Please enter phone number");
        }

        if (phone.length < 10) {
            return toast.error("Enter valid phone number");
        }

        try {
            setLoading(true);

            // ===========================
            // CALL SEND OTP API HERE
            // ===========================
            const res = await authApi.forgotPassword({
                mobileNumber: phone,
                role: "ADMIN",
            });

            console.log("Forgot Password API Response: ", res.status); // Log the API response for debugging

            if (res?.status === 200) {

                toast.success("OTP sent successfully");

                setStep(2);
            } else {
                toast.error(res?.message || "Something went wrong");
            }

        } catch (error) {
            console.error(error);
            toast.error("Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async () => {
        if (!otp.trim()) {
            return toast.error("Please enter OTP");
        }

        try {
            setLoading(true);

            // ===========================
            // CALL VERIFY OTP API HERE
            // ===========================
            const response = await authApi.verifyOtp({
                mobileNumber: phone,
                otp: otp,
                purpose: "TO_RESET_PASSWORD",
                role: "ADMIN",
            });

            console.log("Verify OTP API Response:", response);

            const resetToken = response?.data?.data?.resetToken;

            if (response.status === 200) {
                toast.success("OTP verified successfully");
                navigate("/auth/reset-password", {
                    state: {
                        phone,
                        resetToken,
                    },
                });
            }
        } catch (error) {
            console.error(error);
            toast.error("Invalid OTP");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f5f5f5"
            p={2}
        >
            <Card sx={{ width: 450, maxWidth: "100%" }}>
                <CardContent>
                    <Typography
                        variant="h4"
                        textAlign="center"
                        mb={1}
                        fontWeight={600}
                    >
                        Forgot Password
                    </Typography>

                    <Typography
                        variant="body2"
                        textAlign="center"
                        color="text.secondary"
                        mb={4}
                    >
                        {step === 1
                            ? "Enter your registered phone number"
                            : "Enter the OTP sent to your phone"}
                    </Typography>

                    {step === 1 && (
                        <>
                            <FormControl fullWidth>
                                <InputLabel>Phone Number</InputLabel>
                                <OutlinedInput
                                    label="Phone Number"
                                    value={phone}
                                    onChange={(e) =>
                                        setPhone(e.target.value.replace(/\D/g, ""))
                                    }
                                />
                                <FormHelperText>
                                    Enter your registered mobile number
                                </FormHelperText>
                            </FormControl>

                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                sx={{ mt: 3 }}
                                onClick={handleSendOtp}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={22} /> : "Send OTP"}
                            </Button>
                        </>
                    )}

                    {step === 2 && (
                        <>
                            <FormControl fullWidth>
                                <InputLabel>OTP</InputLabel>
                                <OutlinedInput
                                    label="OTP"
                                    value={otp}
                                    onChange={(e) =>
                                        setOtp(e.target.value.replace(/\D/g, ""))
                                    }
                                />
                            </FormControl>

                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                sx={{ mt: 3 }}
                                onClick={handleVerifyOtp}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={22} /> : "Verify OTP"}
                            </Button>

                            <Button
                                fullWidth
                                variant="text"
                                sx={{ mt: 1 }}
                                onClick={() => {
                                    setOtp("");
                                    setStep(1);
                                }}
                            >
                                Change Phone Number
                            </Button>
                        </>
                    )}

                    <Button
                        fullWidth
                        variant="outlined"
                        sx={{ mt: 3 }}
                        onClick={() => navigate("/auth/login")}
                    >
                        Back to Login
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ForgotPassword;